import React from 'react';
import Component from './Component';
import DatePickerBase from 'react-datepicker';
import {Select} from 'reactis-forms';
import Moment from 'moment';

export default class DateTimePicker extends Component {

	static rules = {
		format: {
			pattern: /^(\d\d?[.]\d\d?[.]\d{4} \d\d?:\d\d?:\d\d?)|(\d{4}-\d\d-\d\d \d\d:\d\d(:\d\d)?)$/,
			message: 'Zadejte datum ve formátu d.m.rrrr h:mm!'
		},
		datetime: {
			message: 'Zadejte platné datum!'
		}
	};

	static defaultProps = {
		clearable: true,
		showTime: true
	};

	handleChange(value) {
		if (this.props.onChange) {
			this.props.onChange(value ? value.format('YYYY-MM-DD HH:mm:ss') : null)
		}
	}

	handleBlur(e) {
		if (this.props.onBlur) {
			this.props.onBlur(this.props.value);
		}
	}

	getError() {
		return this.props.error && this.props.error[0];
	}

	handleChangeHour(val) {
		let value = this.getMoment();
		if (!value) {
			value = Moment();
		}
		value.hour(val);
		if (this.props.onChange) {
			this.props.onChange(value ? value.format('YYYY-MM-DD HH:mm:ss') : null)
		}
	}

	handleChangeMinute(val) {
		let value = this.getMoment();
		if (!value) {
			value = Moment();
		}
		value.minute(val);
		if (this.props.onChange) {
			this.props.onChange(value ? value.format('YYYY-MM-DD HH:mm:ss') : null)
		}
	}

	getMoment() {
		let value = this.props.value;
		let mvalue = null;
		let selectedDate = value ? new Moment(value, 'YYYY-MM-DD HH:mm:ss') : null;
		const isValid = value ? selectedDate.isValid() : false;
		const isISO = isValid && (value == selectedDate.toISOString() ||
				value == Moment(selectedDate).format("YYYY-MM-DD") ||
				value == Moment(selectedDate).format("YYYY-MM-DD HH:mm") ||
				value == Moment(selectedDate).format("YYYY-MM-DD HH:mm:ss")
			);

		if (isValid) {
			if (isISO) {
				mvalue = new Moment(selectedDate);
			}
		}
		else {

		}
		return mvalue;
	}

	render() {
		const mvalue = this.getMoment();
		const hours = [];
		for (let i = 0; i < 24; i++) {
			hours.push({id: i.toString(), title: i});
		}
		const minutes = [];
		for (let i = 0; i < 60; i += 5) {
			let x = i;
			if (i < 10) {
				x = '0' + i.toString();
			}
			minutes.push({id: x.toString(), title: x});
		}

		return (
			<div className={this.getError() ? 'has-error' : ""}>
				<div className="datetimepicker">
					<table>
						<tbody>
						<tr>
							<td style={{width: 100}}>
								<DatePickerBase {...this.props}
												className="form-control"
												locale="cs"
												isClearable={this.props.clearable}
												todayButton="Dnes"
												dateFormat="D.M.YYYY"
												selected={mvalue}
												onChange={(value) => this.handleChange(value)}
												onBlur={(e) => this.handleBlur(e)}
								/>
							</td>
							{this.props.showTime &&
							<td>
								<Select options={hours} onChange={(val) => this.handleChangeHour(val)} style={{width:55}} clearable={false} placeholder="" value={mvalue ? mvalue.format('H') : ''} />
							</td>}
							{this.props.showTime &&
							<td>
								:
							</td>}
							{this.props.showTime &&
							<td>
								<Select options={minutes} onChange={(val) => this.handleChangeMinute(val)} style={{width:55}} clearable={false} placeholder="" value={mvalue ? mvalue.format('mm') : ''} />
							</td>}
						</tr>
						</tbody>
					</table>
				</div>
				{this.getError() && <div className="error-block">{this.getError()}</div>}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/DateTimePicker.js